// React Basic and Bootstrap
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import classnames from 'classnames';

//Import Components
import SectionTitle from "../../components/Shared/section-title";

//import images
import user_interface from '../../images/user/login.png';
import analyzeReport4 from '../../images/illustrator/analyze_report_4.svg';
import app_development_SVG from '../../images/illustrator/app_development_SVG.svg';


class ShowCase extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <section className="section bg-light" id="focus">
                    <Container>
                        {/* section title */}
                        <SectionTitle title="Nuestro objetivo es ayudarte a mejorar" desc="" />

                        <Row className="align-items-center mt-5 mb-5 pt-5 pb-5">
                            <Col md={{size:5, order:1}} xs={{order:1}}>
                                <img src={user_interface} className="img-fluid" alt="" />
                            </Col>

                            <Col md={{size:1, order:1}} xs={{order:1}}/>

                            <Col md={{size:6, order:1}} xs={{order:2}} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                                <div className="section-title mr-lg-5">
                                    <h4 className="title mb-4">Entregamos autoservicio para tus colaboradores</h4>
                                    <p className="text-muted">Nos centramos únicamente en las necesidades más importantes que tu organización espera. Gracias al diseño y desarrollo, permite una alta adopción por parte de los colaboradores en la aplicación, donde en muy pocos pasos realizan sus actividades de gestión de gastos y logran recibir tempranamente respuesta de ello.</p>
                                    {/* <Link to="#" className="btn btn-outline-primary">Start Now <i className="mdi mdi-chevron-right"></i></Link> */}
                                </div>
                            </Col>
                        </Row>

                        <Row className="align-items-center mt-5 mb-5 pt-5 pb-5">
                            <Col md={{size:6, order:1}} xs={{order:2}} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                                <div className="section-title mr-lg-5">
                                    <h4 className="title mb-4">Gestiona en menos tiempo y de forma más eficiente</h4>
                                    <p className="text-muted">Permite a tus lideres de forma sencilla aprobar y corroborar los pagos gracias a la entrega de alertas y facilitando la automatización de corrección de las rendiciones, disminuyendo drásticiamente los tiempos de gestión. Además, permitimos la integración con tu sistema de ERP cumpliendo con una solución punto a punto.</p>
                                    {/* <Link to="#" className="btn btn-outline-primary">Start Now <i className="mdi mdi-chevron-right"></i></Link> */}
                                </div>
                            </Col>

                            <Col md={{size:1, order:1}} xs={{order:1}}/>

                            <Col md={{size:5, order:1}} xs={{order:1}}>
                                <img src={analyzeReport4} className="img-fluid" alt="" />
                            </Col>
                        </Row>

                        <Row className="align-items-center mt-5 mb-5 pt-5 pb-5">
                            <Col md={{size:5, order:1}} xs={{order:1}}>
                                <img src={app_development_SVG} className="img-fluid" alt="" />
                            </Col>

                            <Col md={{size:1, order:1}} xs={{order:1}}/>

                            <Col md={{size:6, order:1}} xs={{order:2}} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                                <div className="section-title mr-lg-5">
                                    <h4 className="title mb-4">Estamos en continuo desarrollo y evolución</h4>
                                    <p className="text-muted">Buscamos en los usuarios la oportunidad de que tengan cada vez más una mejor experiencia y cada vez mejor rendimiento en su gestión. Consideramos importante la atención a los usuarios y semanalmente lanzamos nuevas versiones</p>
                                    {/* <Link to="#" className="btn btn-outline-primary">Start Now <i className="mdi mdi-chevron-right"></i></Link> */}
                                </div>
                            </Col>
                        </Row>
                    </Container>

                </section>
            </React.Fragment>
        );
    }
}

export default ShowCase;
